const toBase64 = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const transparentPixel =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

const loadIcon = async (url) => {
  try {
    return await toBase64(url);
  } catch (e) {
    return transparentPixel;
  }
};

export const decoratePdf = async ({
  pdf,
  headerLogo,
  watermark,
  totalPages,
  pageWidth,
  pageHeight,
}) => {
  const phoneIcon = await loadIcon(
    "https://img.icons8.com/ios/50/ffffff/phone.png",
  );
  const emailIcon = await loadIcon(
    "https://img.icons8.com/ios/50/ffffff/new-post.png",
  );
  const globeIcon = await loadIcon(
    "https://img.icons8.com/ios/50/ffffff/internet--v1.png",
  );
  const telegramIcon = await loadIcon(
    "https://img.icons8.com/ios/50/ffffff/telegram.png",
  );

  return new Promise((resolve) => {
    const headerImg = new Image();
    const watermarkImg = new Image();
    let imagesLoaded = 0;
    const totalImages = 2;

    const processPages = () => {
      let headerImgBase64 = transparentPixel;
      if (headerImg.complete && headerImg.naturalWidth > 0) {
        try {
          const headerCanvas = document.createElement("canvas");
          const headerCtx = headerCanvas.getContext("2d");
          headerCanvas.width = headerImg.naturalWidth || headerImg.width;
          headerCanvas.height = headerImg.naturalHeight || headerImg.height;
          headerCtx.fillStyle = "white";
          headerCtx.fillRect(0, 0, headerCanvas.width, headerCanvas.height);
          headerCtx.drawImage(
            headerImg,
            0,
            0,
            headerCanvas.width,
            headerCanvas.height,
          );
          headerImgBase64 = headerCanvas.toDataURL("image/png");
        } catch (e) {
          console.error("Error drawing header logo:", e);
        }
      }

      let watermarkBase64 = null;
      if (watermarkImg.complete && watermarkImg.naturalWidth > 0) {
        try {
          const watermarkCanvas = document.createElement("canvas");
          const watermarkCtx = watermarkCanvas.getContext("2d");
          watermarkCanvas.width = watermarkImg.naturalWidth || watermarkImg.width;
          watermarkCanvas.height =
            watermarkImg.naturalHeight || watermarkImg.height;
          watermarkCtx.globalAlpha = 0.2;
          watermarkCtx.drawImage(
            watermarkImg,
            0,
            0,
            watermarkCanvas.width,
            watermarkCanvas.height,
          );
          watermarkBase64 = watermarkCanvas.toDataURL("image/png");
        } catch (e) {
          console.error("Error drawing watermark:", e);
        }
      }

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);

        pdf.setFillColor(32, 178, 221);
        pdf.rect(0, 0, pageWidth, 0.5, "F");

        const logoWidth = 1.25;
        const logoHeight = 0.5;
        const logoXPos = 0.6;
        const logoYPos = 0;

        pdf.setFillColor(255, 255, 255);
        pdf.rect(logoXPos, logoYPos, logoWidth, logoHeight, "F");

        if (headerImgBase64) {
          pdf.addImage(
            headerImgBase64,
            "PNG",
            logoXPos,
            logoYPos,
            logoWidth,
            logoHeight,
          );
        }

        pdf.setFillColor(32, 178, 221);
        pdf.rect(0, pageHeight - 0.65, pageWidth, 0.65, "F");

        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(7.5);

        const footerH = 0.6;
        const footerY = pageHeight - footerH;

        const iconSize = 13 / 96;
        const vOffset = 9 / 96;
        const textGap = 25 / 96;

        const col1 = pageWidth * 0.08;
        const col2 = pageWidth * 0.42;
        const col3 = pageWidth * 0.78;

        const rowTop = footerY + 0.16;
        const rowBottom = footerY + 0.35;

        pdf.addImage(phoneIcon, "PNG", col1 - textGap, rowTop - vOffset, iconSize, iconSize);
        pdf.text("+91-9773890604", col1, rowTop);

        pdf.addImage(telegramIcon, "PNG", col1 - textGap, rowBottom - vOffset, iconSize, iconSize);
        pdf.text("t.me/edukemycivilservices", col1, rowBottom);

        pdf.addImage(emailIcon, "PNG", col2 - textGap, rowTop - vOffset, iconSize, iconSize);
        pdf.text("admissions@edukemy.com", col2, rowTop);

        pdf.addImage(telegramIcon, "PNG", col2 - textGap, rowBottom - vOffset, iconSize, iconSize);
        pdf.text("t.me/GeographywithEDUKEMY", col2, rowBottom);

        pdf.addImage(globeIcon, "PNG", col3 - textGap, rowTop - vOffset, iconSize, iconSize);
        pdf.text("www.edukemy.com", col3, rowTop);

        pdf.addImage(telegramIcon, "PNG", col3 - textGap, rowBottom - vOffset, iconSize, iconSize);
        pdf.text("t.me/askyooki", col3, rowBottom);
      }

      if (watermarkBase64 && watermarkImg.width > 0) {
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const imgWidth = pageWidth * 0.8;
          const imgWidthToUse = isNaN(imgWidth) ? 0.8 : imgWidth;
          const imgHeight =
            (watermarkImg.height / watermarkImg.width) * imgWidthToUse;
          const imgHeightToUse = isNaN(imgHeight) ? 0.8 : imgHeight;
          const xPos = (pageWidth - imgWidthToUse) / 2;
          const yPos = (pageHeight - imgHeightToUse) / 2;

          pdf.addImage(
            watermarkBase64,
            "PNG",
            xPos,
            yPos,
            imgWidthToUse,
            imgHeightToUse,
            null,
            "NONE",
          );
        }
      }

      resolve();
    };

    headerImg.onload = () => {
      imagesLoaded++;
      if (imagesLoaded === totalImages) processPages();
    };

    watermarkImg.onload = () => {
      imagesLoaded++;
      if (imagesLoaded === totalImages) processPages();
    };

    headerImg.onerror = () => {
      imagesLoaded++;
      if (imagesLoaded === totalImages) processPages();
    };

    watermarkImg.onerror = () => {
      imagesLoaded++;
      if (imagesLoaded === totalImages) processPages();
    };

    headerImg.src = headerLogo;
    watermarkImg.src = watermark;
  });
};
